var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor" },
    [
      _c("div", { staticClass: "editor-title" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.selectedIndex === "page"
                ? _vm.data.page.name
                : _vm.curItem.name
            )
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.selectedIndex === "page"
        ? _c(
            "div",
            { staticClass: "editor-content" },
            [
              _c(
                "a-tabs",
                [
                  _c("a-tab-pane", { key: "1", attrs: { tab: "页面设置" } }, [
                    _c("div", { staticClass: "block-box" }, [
                      _c("div", { staticClass: "block-title" }, [
                        _vm._v("基本信息"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "block-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("页面名称"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-box" },
                          [
                            _c("a-input", {
                              model: {
                                value: _vm.data.page.params.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data.page.params, "name", $$v)
                                },
                                expression: "data.page.params.name",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tips" }, [
                              _vm._v("页面名称仅用于后台管理"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "block-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("分享标题"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-box" },
                          [
                            _c("a-input", {
                              model: {
                                value: _vm.data.page.params.shareTitle,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.data.page.params,
                                    "shareTitle",
                                    $$v
                                  )
                                },
                                expression: "data.page.params.shareTitle",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tips" }, [
                              _vm._v("用户端转发时显示的标题"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "block-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("页面背景色"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-colorPicker" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "rest-color",
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditorResetColor(
                                      _vm.data.page.style,
                                      "backgroundColor",
                                      "#fff"
                                    )
                                  },
                                },
                              },
                              [_vm._v("重置")]
                            ),
                            _vm._v(" "),
                            _c("colorPicker", {
                              attrs: { defaultColor: "#fff" },
                              model: {
                                value: _vm.data.page.style.backgroundColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.data.page.style,
                                    "backgroundColor",
                                    $$v
                                  )
                                },
                                expression: "data.page.style.backgroundColor",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("a-tab-pane", { key: "2", attrs: { tab: "标题栏设置" } }, [
                    _c("div", { staticClass: "block-box" }, [
                      _c("div", { staticClass: "block-title" }, [
                        _vm._v("标题栏设置"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "block-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("标题名称"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-box" },
                          [
                            _c("a-input", {
                              model: {
                                value: _vm.data.page.params.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data.page.params, "title", $$v)
                                },
                                expression: "data.page.params.title",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "tips" }, [
                              _vm._v("用户端端顶部显示的标题"),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "block-item" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("文字颜色"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-radio-group",
                            {
                              attrs: { buttonStyle: "solid" },
                              model: {
                                value: _vm.data.page.style.titleTextColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.data.page.style,
                                    "titleTextColor",
                                    $$v
                                  )
                                },
                                expression: "data.page.style.titleTextColor",
                              },
                            },
                            [
                              _c(
                                "a-radio-button",
                                { attrs: { value: "white" } },
                                [_vm._v("白色")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-radio-button",
                                { attrs: { value: "black" } },
                                [_vm._v("黑色")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "block-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("标题栏背景"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item-colorPicker" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "rest-color",
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditorResetColor(
                                      _vm.data.page.style,
                                      "titleBackgroundColor",
                                      "#fff"
                                    )
                                  },
                                },
                              },
                              [_vm._v("重置")]
                            ),
                            _vm._v(" "),
                            _c("colorPicker", {
                              attrs: { defaultColor: "#fff" },
                              model: {
                                value: _vm.data.page.style.titleBackgroundColor,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.data.page.style,
                                    "titleBackgroundColor",
                                    $$v
                                  )
                                },
                                expression:
                                  "data.page.style.titleBackgroundColor",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.data.items.length && _vm.curItem
        ? [
            _vm.curItem.type == "search"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("功能设置"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("提示文字"),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    model: {
                                      value: _vm.curItem.params.placeholder,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.curItem.params,
                                          "placeholder",
                                          $$v
                                        )
                                      },
                                      expression: "curItem.params.placeholder",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("内容样式"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("搜索框样式"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.searchStyle,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "searchStyle",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.searchStyle",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "square" } },
                                        [_vm._v("方形")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "radius" } },
                                        [_vm._v("圆角")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "round" } },
                                        [_vm._v("圆弧")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("文字对齐"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.textAlign,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "textAlign",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.textAlign",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "left" } },
                                        [_vm._v("居左")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "center" } },
                                        [_vm._v("居中")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "right" } },
                                        [_vm._v("居右")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "blank"
              ? _c("div", { staticClass: "editor-content" }, [
                  _c("div", { staticClass: "block-box" }, [
                    _c("div", { staticClass: "block-title" }, [
                      _vm._v("样式设置"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("组件高度"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-slider" },
                        [
                          _c("a-slider", {
                            attrs: { min: 5, max: 200 },
                            model: {
                              value: _vm.curItem.style.height,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "height", $$v)
                              },
                              expression: "curItem.style.height",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "unit-text" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.curItem.style.height)),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("像素")]),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("背景颜色"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-colorPicker" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "rest-color",
                              on: {
                                click: function ($event) {
                                  return _vm.onEditorResetColor(
                                    _vm.curItem.style,
                                    "background",
                                    "#"
                                  )
                                },
                              },
                            },
                            [_vm._v("透明")]
                          ),
                          _vm._v(" "),
                          _c("colorPicker", {
                            attrs: { defaultColor: "" },
                            model: {
                              value: _vm.curItem.style.background,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "background", $$v)
                              },
                              expression: "curItem.style.background",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "guide"
              ? _c("div", { staticClass: "editor-content" }, [
                  _c("div", { staticClass: "block-box" }, [
                    _c("div", { staticClass: "block-title" }, [
                      _vm._v("样式设置"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "block-item" },
                      [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("线条样式"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-radio-group",
                          {
                            attrs: { buttonStyle: "solid" },
                            model: {
                              value: _vm.curItem.style.lineStyle,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "lineStyle", $$v)
                              },
                              expression: "curItem.style.lineStyle",
                            },
                          },
                          [
                            _c(
                              "a-radio-button",
                              { attrs: { value: "solid" } },
                              [_vm._v("实线")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "dashed" } },
                              [_vm._v("虚线")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-radio-button",
                              { attrs: { value: "dotted" } },
                              [_vm._v("点状")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("线条颜色"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-colorPicker" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "rest-color",
                              on: {
                                click: function ($event) {
                                  return _vm.onEditorResetColor(
                                    _vm.curItem.style,
                                    "lineColor",
                                    "#000"
                                  )
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                          _vm._v(" "),
                          _c("colorPicker", {
                            attrs: { defaultColor: "#000" },
                            model: {
                              value: _vm.curItem.style.lineColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "lineColor", $$v)
                              },
                              expression: "curItem.style.lineColor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("线条高度"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-slider" },
                        [
                          _c("a-slider", {
                            attrs: { min: 1, max: 20 },
                            model: {
                              value: _vm.curItem.style.lineHeight,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "lineHeight", $$v)
                              },
                              expression: "curItem.style.lineHeight",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "unit-text" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.curItem.style.lineHeight)),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("像素")]),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("上下边距"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-slider" },
                        [
                          _c("a-slider", {
                            attrs: { min: 0, max: 50 },
                            model: {
                              value: _vm.curItem.style.paddingTop,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "paddingTop", $$v)
                              },
                              expression: "curItem.style.paddingTop",
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "unit-text" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.curItem.style.paddingTop)),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("像素")]),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "block-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("背景颜色"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-colorPicker" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "rest-color",
                              on: {
                                click: function ($event) {
                                  return _vm.onEditorResetColor(
                                    _vm.curItem.style,
                                    "background",
                                    "#fff"
                                  )
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                          _vm._v(" "),
                          _c("colorPicker", {
                            attrs: { defaultColor: "#fff" },
                            model: {
                              value: _vm.curItem.style.background,
                              callback: function ($$v) {
                                _vm.$set(_vm.curItem.style, "background", $$v)
                              },
                              expression: "curItem.style.background",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "richText"
              ? _c(
                  "div",
                  { staticClass: "editor-content", style: { width: "395px" } },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("文本内容"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "ueditor" },
                                [
                                  _c("Tinymce", {
                                    attrs: { height: 360 },
                                    model: {
                                      value: _vm.curItem.params.content,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.curItem.params,
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression: "curItem.params.content",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("背景颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              "#"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("透明")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "" },
                                      model: {
                                        value: _vm.curItem.style.background,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "background",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.background",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "notice"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("公告文案"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("内容"),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    model: {
                                      value: _vm.curItem.params.text,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.curItem.params,
                                          "text",
                                          $$v
                                        )
                                      },
                                      expression: "curItem.params.text",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("链接"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-box" },
                                  [
                                    _c("SLink", {
                                      model: {
                                        value: _vm.curItem.params.link,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params,
                                            "link",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.params.link",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("内容样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("文字颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "textColor",
                                              "#000"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#000" },
                                      model: {
                                        value: _vm.curItem.style.textColor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "textColor",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.textColor",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("背景颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              "#fff"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#fff" },
                                      model: {
                                        value: _vm.curItem.style.background,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "background",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.background",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-slider" },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "article"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("文章内容"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("文章分类"),
                                  ]),
                                  _vm._v(" "),
                                  _c("SArticleCate", {
                                    model: {
                                      value: _vm.curItem.params.auto.category,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.curItem.params.auto,
                                          "category",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "curItem.params.auto.category",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("显示数量"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "block-item-right" },
                                  [
                                    _c("a-input-number", {
                                      attrs: { min: 1, max: 20 },
                                      model: {
                                        value: _vm.curItem.params.auto.showNum,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params.auto,
                                            "showNum",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.params.auto.showNum",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [_vm._v("篇")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("列表元素组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.itemPaddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "itemPaddingTop",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.style.itemPaddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.curItem.style.itemPaddingTop
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value:
                                          _vm.curItem.style.itemPaddingLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "itemPaddingLeft",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.style.itemPaddingLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.curItem.style.itemPaddingLeft
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("图片位置"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.imgPosition,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "imgPosition",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.imgPosition",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "left" } },
                                        [_vm._v("左侧")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "right" } },
                                        [_vm._v("右侧")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("显示内容"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-checkbox",
                                    style: { width: "180px" },
                                  },
                                  [
                                    _c(
                                      "a-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.curItem.style.show,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.curItem.style,
                                              "show",
                                              $$v
                                            )
                                          },
                                          expression: "curItem.style.show",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-checkbox",
                                          { attrs: { value: "category" } },
                                          [_vm._v("分类")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-checkbox",
                                          { attrs: { value: "viewsNum" } },
                                          [_vm._v("浏览次数")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("分类颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              "blue"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "blue" },
                                      model: {
                                        value: _vm.curItem.style.categoryColor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "categoryColor",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.style.categoryColor",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("圆角"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.borderRadius,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "borderRadius",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.style.borderRadius",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.borderRadius)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "service"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("功能设置"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("客服类型"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.params.type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params,
                                            "type",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.params.type",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "chat" } },
                                        [_vm._v("在线聊天")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "phone" } },
                                        [_vm._v("拨打电话")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.curItem.params.type == "phone",
                                      expression:
                                        "curItem.params.type == 'phone'",
                                    },
                                  ],
                                  staticClass: "block-item",
                                },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("电话号码"),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-input", {
                                    model: {
                                      value: _vm.curItem.params.tel,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.curItem.params, "tel", $$v)
                                      },
                                      expression: "curItem.params.tel",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("客服图标"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tips-wrap" }, [
                                    _vm._v("建议尺寸：90×90"),
                                  ]),
                                  _vm._v(" "),
                                  _c("SImage", {
                                    attrs: { width: 60, height: 60 },
                                    model: {
                                      value: _vm.curItem.params.image,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.curItem.params,
                                          "image",
                                          $$v
                                        )
                                      },
                                      expression: "curItem.params.image",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("底边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-slider" },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.bottom,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "bottom",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.bottom",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.bottom)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("右边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-slider" },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.right,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "right",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.right",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.curItem.style.right)),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("不透明度"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-slider" },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 100 },
                                      model: {
                                        value: _vm.curItem.style.opacity,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "opacity",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.opacity",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.opacity)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("%")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "video"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("功能设置"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("视频地址"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-box" },
                                  [
                                    _c("a-input", {
                                      model: {
                                        value: _vm.curItem.params.videoUrl,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params,
                                            "videoUrl",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.params.videoUrl",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "tips" }, [
                                      _vm._v("仅支持.mp4格式的视频源地址"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("视频封面"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-box" },
                                  [
                                    _c("SImage", {
                                      attrs: { width: 160, height: 90 },
                                      model: {
                                        value: _vm.curItem.params.poster,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params,
                                            "poster",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.params.poster",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "tips" }, [
                                      _vm._v("建议封面图片尺寸与视频比例一致"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("播放设置"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("自动播放"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tips-wrap" }, [
                                    _vm._v("仅支持小程序"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.params.autoplay,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params,
                                            "autoplay",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.params.autoplay",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 1 } },
                                        [_vm._v("开启")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 0 } },
                                        [_vm._v("关闭")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _c("span", [_vm._v("内容样式")]),
                                _vm._v(" "),
                                _c("span", { staticClass: "tips" }, [
                                  _vm._v("视频宽度为750像素"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("视频高度"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-slider" },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 50, max: 400 },
                                      model: {
                                        value: _vm.curItem.style.height,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "height",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.height",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.height)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-slider" },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "image"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "sub-title" }, [
                              _vm._v("添加图片 (最多10张，可拖动排序）"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              _vm._b(
                                { attrs: { list: _vm.curItem.data } },
                                "draggable",
                                {
                                  animation: 120,
                                  filter: "input",
                                  preventOnFilter: false,
                                },
                                false
                              ),
                              _vm._l(_vm.curItem.data, function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "block-box drag" },
                                  [
                                    _c("div", { staticClass: "block-title" }, [
                                      _c("span", { staticClass: "left" }, [
                                        _vm._v("图片 " + _vm._s(index + 1)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleleData(
                                                _vm.curItem,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "block-item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-item-common" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("图片")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "label value" },
                                                [_vm._v(_vm._s(item.imgName))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("链接")]
                                              ),
                                              _vm._v(" "),
                                              _c("SLink", {
                                                model: {
                                                  value: item.link,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "link", $$v)
                                                  },
                                                  expression: "item.link",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-item-custom" },
                                        [
                                          _c("SImage", {
                                            attrs: { tips: "建议尺寸：宽750" },
                                            on: {
                                              update: function ($event) {
                                                item.imgName = $event.file_name
                                              },
                                            },
                                            model: {
                                              value: item.imgUrl,
                                              callback: function ($$v) {
                                                _vm.$set(item, "imgUrl", $$v)
                                              },
                                              expression: "item.imgUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.curItem.data.length < 10
                              ? _c(
                                  "div",
                                  { staticClass: "data-add" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { icon: "plus" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddData(10)
                                          },
                                        },
                                      },
                                      [_vm._v("添加图片")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("背景颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              ""
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "''" },
                                      model: {
                                        value: _vm.curItem.style.background,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "background",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.background",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "banner"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "sub-title" }, [
                              _vm._v("添加图片 (最多10张，可拖动排序）"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              _vm._b(
                                { attrs: { list: _vm.curItem.data } },
                                "draggable",
                                {
                                  animation: 120,
                                  filter: "input",
                                  preventOnFilter: false,
                                },
                                false
                              ),
                              _vm._l(_vm.curItem.data, function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "block-box drag" },
                                  [
                                    _c("div", { staticClass: "block-title" }, [
                                      _c("span", { staticClass: "left" }, [
                                        _vm._v("图片 " + _vm._s(index + 1)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleleData(
                                                _vm.curItem,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "block-item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-item-common" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("图片")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "label value" },
                                                [_vm._v(_vm._s(item.imgName))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("链接")]
                                              ),
                                              _vm._v(" "),
                                              _c("SLink", {
                                                model: {
                                                  value: item.link,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "link", $$v)
                                                  },
                                                  expression: "item.link",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-item-custom" },
                                        [
                                          _c("SImage", {
                                            attrs: {
                                              tips: "建议尺寸：750×400",
                                            },
                                            on: {
                                              update: function ($event) {
                                                item.imgName = $event.file_name
                                              },
                                            },
                                            model: {
                                              value: item.imgUrl,
                                              callback: function ($$v) {
                                                _vm.$set(item, "imgUrl", $$v)
                                              },
                                              expression: "item.imgUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.curItem.data.length < 10
                              ? _c(
                                  "div",
                                  { staticClass: "data-add" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { icon: "plus" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddData(10)
                                          },
                                        },
                                      },
                                      [_vm._v("添加图片")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("内容样式"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("指示点形状"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.btnShape,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "btnShape",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.btnShape",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "round" } },
                                        [_vm._v("圆形")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "square" } },
                                        [_vm._v("正方形")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "rectangle" } },
                                        [_vm._v("长方形")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("指示点颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "btnColor",
                                              "#fff"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#fff" },
                                      model: {
                                        value: _vm.curItem.style.btnColor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "btnColor",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.btnColor",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("切换时间"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    staticStyle: { width: "190px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { step: 1, min: 1, max: 20 },
                                      model: {
                                        value: _vm.curItem.style.interval,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "interval",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.interval",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.interval)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("秒")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "goods"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c(
                                "div",
                                { staticClass: "block-title" },
                                [
                                  _c("span", [_vm._v("商品来源")]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.params.source,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.params,
                                            "source",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.params.source",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "auto" } },
                                        [_vm._v("自动获取")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "choice" } },
                                        [_vm._v("手动选择")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.curItem.params.source === "choice"
                              ? _c(
                                  "div",
                                  { staticClass: "block-box" },
                                  [
                                    _c("div", { staticClass: "block-title" }, [
                                      _vm._v(
                                        "选择商品 (" +
                                          _vm._s(_vm.curItem.data.length) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("SGoods", {
                                      model: {
                                        value: _vm.curItem.data,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.curItem, "data", $$v)
                                        },
                                        expression: "curItem.data",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curItem.params.source === "auto"
                              ? _c("div", { staticClass: "block-box" }, [
                                  _c("div", { staticClass: "block-title" }, [
                                    _vm._v("商品内容"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "block-item" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v("商品分类"),
                                      ]),
                                      _vm._v(" "),
                                      _c("SGoodsCate", {
                                        model: {
                                          value:
                                            _vm.curItem.params.auto.category,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.curItem.params.auto,
                                              "category",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "curItem.params.auto.category",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "block-item" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v("业务类型"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a-select",
                                        {
                                          staticStyle: { width: "220px" },
                                          model: {
                                            value:
                                              _vm.curItem.params.auto.bizType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.curItem.params.auto,
                                                "bizType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "curItem.params.auto.bizType",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: 1 } },
                                            [_vm._v("普通商品")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: 2 } },
                                            [_vm._v("积分商品")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: 3 } },
                                            [_vm._v("租赁商品")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "block-item" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v("商品排序"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-group",
                                        {
                                          attrs: { buttonStyle: "solid" },
                                          model: {
                                            value:
                                              _vm.curItem.params.auto.goodsSort,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.curItem.params.auto,
                                                "goodsSort",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "curItem.params.auto.goodsSort",
                                          },
                                        },
                                        [
                                          _c(
                                            "a-radio-button",
                                            { attrs: { value: "all" } },
                                            [_vm._v("默认")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-radio-button",
                                            { attrs: { value: "sales" } },
                                            [_vm._v("销量")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-radio-button",
                                            { attrs: { value: "price" } },
                                            [_vm._v("价格")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "block-item" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("显示数量"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "block-item-right" },
                                      [
                                        _c("a-input-number", {
                                          attrs: { min: 1, max: 50 },
                                          model: {
                                            value:
                                              _vm.curItem.params.auto.showNum,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.curItem.params.auto,
                                                "showNum",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "curItem.params.auto.showNum",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "unit-text" },
                                          [_c("span", [_vm._v("件")])]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("内容样式"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("显示类型"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.display,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "display",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.display",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "list" } },
                                        [_vm._v("列表平铺")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.curItem.style.column === 1,
                                            value: "slide",
                                          },
                                        },
                                        [_vm._v("横向滑动")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("分列数量"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.column,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "column",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.column",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.curItem.style.display !==
                                              "list",
                                            value: 1,
                                          },
                                        },
                                        [_vm._v("单列")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 2 } },
                                        [_vm._v("两列")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 3 } },
                                        [_vm._v("三列")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("显示内容"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-checkbox",
                                    style: { width: "180px" },
                                  },
                                  [
                                    _c(
                                      "a-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.curItem.style.show,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.curItem.style,
                                              "show",
                                              $$v
                                            )
                                          },
                                          expression: "curItem.style.show",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-checkbox",
                                          { attrs: { value: "goodsName" } },
                                          [_vm._v("商品名称")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-checkbox",
                                          { attrs: { value: "goodsPrice" } },
                                          [_vm._v("商品价格")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-checkbox",
                                          { attrs: { value: "linePrice" } },
                                          [_vm._v("划线价格")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-checkbox",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.curItem.style.column ===
                                                  1,
                                                expression:
                                                  "curItem.style.column === 1",
                                              },
                                            ],
                                            attrs: { value: "sellingPoint" },
                                          },
                                          [_vm._v("商品卖点")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-checkbox",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.curItem.style.column ===
                                                  1,
                                                expression:
                                                  "curItem.style.column === 1",
                                              },
                                            ],
                                            attrs: { value: "goodsSales" },
                                          },
                                          [_vm._v("商品销量")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("背景颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              "#fff"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#fff" },
                                      model: {
                                        value: _vm.curItem.style.background,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "background",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.background",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "navBar"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "sub-title" }, [
                              _vm._v(
                                "添加导航 (最少4个，最多10个，可拖动排序)"
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              _vm._b(
                                { attrs: { list: _vm.curItem.data } },
                                "draggable",
                                {
                                  animation: 120,
                                  filter: "input",
                                  preventOnFilter: false,
                                },
                                false
                              ),
                              _vm._l(_vm.curItem.data, function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "block-box drag" },
                                  [
                                    _c("div", { staticClass: "block-title" }, [
                                      _c("span", { staticClass: "left" }, [
                                        _vm._v("导航 " + _vm._s(index + 1)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleleData(
                                                _vm.curItem,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "block-item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-item-common" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("名称")]
                                              ),
                                              _vm._v(" "),
                                              _c("a-input", {
                                                model: {
                                                  value: item.text,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "text", $$v)
                                                  },
                                                  expression: "item.text",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("链接")]
                                              ),
                                              _vm._v(" "),
                                              _c("SLink", {
                                                model: {
                                                  value: item.link,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "link", $$v)
                                                  },
                                                  expression: "item.link",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-item-custom" },
                                        [
                                          _c("SImage", {
                                            attrs: {
                                              tips: "建议尺寸：100×100",
                                            },
                                            model: {
                                              value: item.imgUrl,
                                              callback: function ($$v) {
                                                _vm.$set(item, "imgUrl", $$v)
                                              },
                                              expression: "item.imgUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.curItem.data.length < 10
                              ? _c(
                                  "div",
                                  { staticClass: "data-add" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { icon: "plus" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddData(10)
                                          },
                                        },
                                      },
                                      [_vm._v("添加导航")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("内容样式"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("每行数量"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.rowsNum,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "rowsNum",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.rowsNum",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 3 } },
                                        [_vm._v("3个")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 4 } },
                                        [_vm._v("4个")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 5 } },
                                        [_vm._v("5个")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("文字颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "textColor",
                                              "#000"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#000" },
                                      model: {
                                        value: _vm.curItem.style.textColor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "textColor",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.textColor",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("背景颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              "#fff"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#fff" },
                                      model: {
                                        value: _vm.curItem.style.background,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "background",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.background",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("圆角"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.borderRadius,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "borderRadius",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.style.borderRadius",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.borderRadius)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "window"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "内容设置" } },
                          [
                            _c("div", { staticClass: "sub-title" }, [
                              _vm._v("添加图片 (最多10个，可拖动排序)"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              _vm._b(
                                { attrs: { list: _vm.curItem.data } },
                                "draggable",
                                {
                                  animation: 120,
                                  filter: "input",
                                  preventOnFilter: false,
                                },
                                false
                              ),
                              _vm._l(_vm.curItem.data, function (item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "block-box drag" },
                                  [
                                    _c("div", { staticClass: "block-title" }, [
                                      _c("span", { staticClass: "left" }, [
                                        _vm._v("图片 " + _vm._s(index + 1)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "link",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDeleleData(
                                                _vm.curItem,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "block-item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-item-common" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("名称")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "label value" },
                                                [_vm._v(_vm._s(item.imgName))]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block-item-common-row",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "label" },
                                                [_vm._v("链接")]
                                              ),
                                              _vm._v(" "),
                                              _c("SLink", {
                                                model: {
                                                  value: item.link,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "link", $$v)
                                                  },
                                                  expression: "item.link",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-item-custom" },
                                        [
                                          _c("SImage", {
                                            on: {
                                              update: function ($event) {
                                                item.imgName = $event.file_name
                                              },
                                            },
                                            model: {
                                              value: item.imgUrl,
                                              callback: function ($$v) {
                                                _vm.$set(item, "imgUrl", $$v)
                                              },
                                              expression: "item.imgUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _vm.curItem.data.length < 10
                              ? _c(
                                  "div",
                                  { staticClass: "data-add" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: { icon: "plus" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAddData(10)
                                          },
                                        },
                                      },
                                      [_vm._v("添加图片")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "样式设置" } },
                          [
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("内容样式"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "block-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v("每行数量"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-group",
                                    {
                                      attrs: { buttonStyle: "solid" },
                                      model: {
                                        value: _vm.curItem.style.layout,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "layout",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.layout",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 2 } },
                                        [_vm._v("2列")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 3 } },
                                        [_vm._v("3列")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: 4 } },
                                        [_vm._v("4列")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: -1 } },
                                        [_vm._v("橱窗")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右内边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.paddingLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "paddingLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.paddingLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.paddingLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("上下外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginTop,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginTop",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginTop",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginTop)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("左右外边距"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.marginLeft,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "marginLeft",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.marginLeft",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.marginLeft)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "block-box" }, [
                              _c("div", { staticClass: "block-title" }, [
                                _vm._v("组件样式"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("背景颜色"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "item-colorPicker" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rest-color",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditorResetColor(
                                              _vm.curItem.style,
                                              "background",
                                              "#fff"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _vm._v(" "),
                                    _c("colorPicker", {
                                      attrs: { defaultColor: "#fff" },
                                      model: {
                                        value: _vm.curItem.style.background,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "background",
                                            $$v
                                          )
                                        },
                                        expression: "curItem.style.background",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "block-item" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("圆角"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "item-slider",
                                    style: { width: "210px" },
                                  },
                                  [
                                    _c("a-slider", {
                                      attrs: { min: 0, max: 50 },
                                      model: {
                                        value: _vm.curItem.style.borderRadius,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.curItem.style,
                                            "borderRadius",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "curItem.style.borderRadius",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "unit-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.curItem.style.borderRadius)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("像素")]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "tabList"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      {
                        attrs: { type: "card" },
                        on: { change: _vm.listStyleTemplateHandleTabs },
                      },
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "风格1" } },
                          [
                            _c(
                              "a-tabs",
                              [
                                _c(
                                  "a-tab-pane",
                                  { key: "c1", attrs: { tab: "内容设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("tab接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .tabDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "tabDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.tabDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("列表接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .listDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "listDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.listDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-tab-pane",
                                  { key: "c2", attrs: { tab: "样式设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("列表元素组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("图片位置"),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a-radio-group",
                                            {
                                              attrs: { buttonStyle: "solid" },
                                              model: {
                                                value:
                                                  _vm.curItem.style.imgPosition,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "imgPosition",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.imgPosition",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-radio-button",
                                                { attrs: { value: "left" } },
                                                [_vm._v("左侧")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a-radio-button",
                                                { attrs: { value: "right" } },
                                                [_vm._v("右侧")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("显示内容"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-checkbox",
                                            style: { width: "180px" },
                                          },
                                          [
                                            _c(
                                              "a-checkbox-group",
                                              {
                                                model: {
                                                  value: _vm.curItem.style.show,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.curItem.style,
                                                      "show",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "curItem.style.show",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "category",
                                                    },
                                                  },
                                                  [_vm._v("分类")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "viewsNum",
                                                    },
                                                  },
                                                  [_vm._v("浏览次数")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("分类颜色"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "item-colorPicker" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "rest-color",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditorResetColor(
                                                      _vm.curItem.style,
                                                      "background",
                                                      "blue"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("重置")]
                                            ),
                                            _vm._v(" "),
                                            _c("colorPicker", {
                                              attrs: { defaultColor: "blue" },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .categoryColor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "categoryColor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.categoryColor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("圆角"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .borderRadius,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "borderRadius",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.borderRadius",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .borderRadius
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "风格2" } },
                          [
                            _c(
                              "a-tabs",
                              [
                                _c(
                                  "a-tab-pane",
                                  { key: "c1", attrs: { tab: "内容设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("tab接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .tabDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "tabDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.tabDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("列表接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .listDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "listDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.listDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-tab-pane",
                                  { key: "c2", attrs: { tab: "样式设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("列表元素组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("显示内容"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-checkbox",
                                            style: { width: "180px" },
                                          },
                                          [
                                            _c(
                                              "a-checkbox-group",
                                              {
                                                model: {
                                                  value: _vm.curItem.style.show,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.curItem.style,
                                                      "show",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "curItem.style.show",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "category",
                                                    },
                                                  },
                                                  [_vm._v("分类")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "viewsNum",
                                                    },
                                                  },
                                                  [_vm._v("浏览次数")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("分类颜色"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "item-colorPicker" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "rest-color",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditorResetColor(
                                                      _vm.curItem.style,
                                                      "background",
                                                      "blue"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("重置")]
                                            ),
                                            _vm._v(" "),
                                            _c("colorPicker", {
                                              attrs: { defaultColor: "blue" },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .categoryColor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "categoryColor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.categoryColor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("圆角"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .borderRadius,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "borderRadius",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.borderRadius",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .borderRadius
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.curItem.type == "stickyTabList"
              ? _c(
                  "div",
                  { staticClass: "editor-content" },
                  [
                    _c(
                      "a-tabs",
                      {
                        attrs: { type: "card" },
                        on: { change: _vm.listStyleTemplateHandleTabs },
                      },
                      [
                        _c(
                          "a-tab-pane",
                          { key: "1", attrs: { tab: "风格1" } },
                          [
                            _c(
                              "a-tabs",
                              [
                                _c(
                                  "a-tab-pane",
                                  { key: "c1", attrs: { tab: "内容设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("tab接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .tabDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "tabDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.tabDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("列表接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .listDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "listDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.listDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-tab-pane",
                                  { key: "c2", attrs: { tab: "样式设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("列表元素组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-item" },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("图片位置"),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "a-radio-group",
                                            {
                                              attrs: { buttonStyle: "solid" },
                                              model: {
                                                value:
                                                  _vm.curItem.style.imgPosition,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "imgPosition",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.imgPosition",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-radio-button",
                                                { attrs: { value: "left" } },
                                                [_vm._v("左侧")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a-radio-button",
                                                { attrs: { value: "right" } },
                                                [_vm._v("右侧")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("显示内容"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-checkbox",
                                            style: { width: "180px" },
                                          },
                                          [
                                            _c(
                                              "a-checkbox-group",
                                              {
                                                model: {
                                                  value: _vm.curItem.style.show,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.curItem.style,
                                                      "show",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "curItem.style.show",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "category",
                                                    },
                                                  },
                                                  [_vm._v("分类")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "viewsNum",
                                                    },
                                                  },
                                                  [_vm._v("浏览次数")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("分类颜色"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "item-colorPicker" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "rest-color",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditorResetColor(
                                                      _vm.curItem.style,
                                                      "background",
                                                      "blue"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("重置")]
                                            ),
                                            _vm._v(" "),
                                            _c("colorPicker", {
                                              attrs: { defaultColor: "blue" },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .categoryColor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "categoryColor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.categoryColor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("圆角"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .borderRadius,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "borderRadius",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.borderRadius",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .borderRadius
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tab-pane",
                          { key: "2", attrs: { tab: "风格2" } },
                          [
                            _c(
                              "a-tabs",
                              [
                                _c(
                                  "a-tab-pane",
                                  { key: "c1", attrs: { tab: "内容设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("tab接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .tabDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "tabDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.tabDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "block-item-common-row",
                                        },
                                        [
                                          _c("span", { staticClass: "label" }, [
                                            _vm._v("列表接口"),
                                          ]),
                                          _vm._v(" "),
                                          _c("a-input", {
                                            model: {
                                              value:
                                                _vm.curItem.params
                                                  .listDataRequestUrl,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.curItem.params,
                                                  "listDataRequestUrl",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "curItem.params.listDataRequestUrl",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-tab-pane",
                                  { key: "c2", attrs: { tab: "样式设置" } },
                                  [
                                    _c("div", { staticClass: "block-box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.paddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "paddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.paddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .paddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右外边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style.marginLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "marginLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.marginLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .marginLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "block-title" },
                                        [_vm._v("列表元素组件样式")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("上下内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingTop,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingTop",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingTop",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingTop
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("左右内边距"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .itemPaddingLeft,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "itemPaddingLeft",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.itemPaddingLeft",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .itemPaddingLeft
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("显示内容"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-checkbox",
                                            style: { width: "180px" },
                                          },
                                          [
                                            _c(
                                              "a-checkbox-group",
                                              {
                                                model: {
                                                  value: _vm.curItem.style.show,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.curItem.style,
                                                      "show",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "curItem.style.show",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "category",
                                                    },
                                                  },
                                                  [_vm._v("分类")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-checkbox",
                                                  {
                                                    attrs: {
                                                      value: "viewsNum",
                                                    },
                                                  },
                                                  [_vm._v("浏览次数")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("分类颜色"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "item-colorPicker" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "rest-color",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditorResetColor(
                                                      _vm.curItem.style,
                                                      "background",
                                                      "blue"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("重置")]
                                            ),
                                            _vm._v(" "),
                                            _c("colorPicker", {
                                              attrs: { defaultColor: "blue" },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .categoryColor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "categoryColor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.categoryColor",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "block-item" }, [
                                        _c("span", { staticClass: "label" }, [
                                          _vm._v("圆角"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "item-slider",
                                            style: { width: "210px" },
                                          },
                                          [
                                            _c("a-slider", {
                                              attrs: { min: 0, max: 50 },
                                              model: {
                                                value:
                                                  _vm.curItem.style
                                                    .borderRadius,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.curItem.style,
                                                    "borderRadius",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "curItem.style.borderRadius",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "unit-text" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.curItem.style
                                                        .borderRadius
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [_vm._v("像素")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }